const dashboard = () => import(/* webpackPrefetch: true */ '@/views/private/index.vue')

const maping = () => import(/* webpackPrefetch: true */ '@/views/private/monitoring/maping/index.vue')
const attendance_monitoring = () => import(/* webpackPrefetch: true */ '@/views/private/monitoring/attendance/index.vue')
const permission = () => import(/* webpackPrefetch: true */ '@/views/private/monitoring/permission/index.vue')

const profile = () => import(/* webpackPrefetch: true */ '@/views/private/profile/index.vue')

const unit = () => import(/* webpackPrefetch: true */ '@/views/private/unit/index.vue')
const unit_struktur = () => import(/* webpackPrefetch: true */ '@/views/private/unit/struktur/index.vue')
const unit_struktur_regulation = () => import(/* webpackPrefetch: true */ '@/views/private/unit/struktur/regulation/index.vue')
const unit_struktur_officer_id = () => import(/* webpackPrefetch: true */ '@/views/private/unit/struktur/officer/_id.vue')
const unit_struktur_officer_regulation_id = () => import(/* webpackPrefetch: true */ '@/views/private/unit/struktur/officer/regulation/_id.vue')
const unit_divisi = () => import(/* webpackPrefetch: true */ '@/views/private/unit/division/index.vue')
const unit_aturan = () => import(/* webpackPrefetch: true */ '@/views/private/unit/aturan/index.vue')

const officer = () => import(/* webpackPrefetch: true */ '@/views/private/officer/index.vue')
const officer_detail = () => import(/* webpackPrefetch: true */ '@/views/private/officer/_id.vue')

const attendance = () => import(/* webpackPrefetch: true */ '@/views/private/attendance/index.vue')
const attendance_history = () => import(/* webpackPrefetch: true */ '@/views/private/attendance/history/_id.vue')
const attendance_rekap = () => import(/* webpackPrefetch: true */ '@/views/private/attendance/rekap/index.vue')
const attendance_late = () => import(/* webpackPrefetch: true */ '@/views/private/attendance/late/index.vue')

const overtime = () => import(/* webpackPrefetch: true */ '@/views/private/overtime/index.vue')
const overtime_history = () => import(/* webpackPrefetch: true */ '@/views/private/overtime/history/index.vue')

const salary = () => import(/* webpackPrefetch: true */ '@/views/private/salary/index.vue')
const salary_history = () => import(/* webpackPrefetch: true */ '@/views/private/salary/history/_id.vue')
const salary_month = () => import(/* webpackPrefetch: true */ '@/views/private/salary/month/index.vue')

const licensing = () => import(/* webpackPrefetch: true */ '@/views/private/licensing/index.vue')
const licensing_holiday = () => import(/* webpackPrefetch: true */ '@/views/private/licensing/holiday/index.vue')
const licensing_history = () => import(/* webpackPrefetch: true */ '@/views/private/licensing/history/_id.vue')
const licensing_permission = () => import(/* webpackPrefetch: true */ '@/views/private/licensing/permission/index.vue')
const licensing_submission = () => import(/* webpackPrefetch: true */ '@/views/private/licensing/submission/index.vue')

const report = () => import(/* webpackPrefetch: true */ '@/views/private/report/index.vue')
const report_detail = () => import(/* webpackPrefetch: true */ '@/views/private/report/history/_id.vue')

const announcement = () => import(/* webpackPrefetch: true */ '@/views/private/announcement/index.vue')
const audit = () => import(/* webpackPrefetch: true */ '@/views/private/audit/index.vue')

const setting = () => import(/* webpackPrefetch: true */ '@/views/private/setting/index.vue')
const setting_config = () => import(/* webpackPrefetch: true */ '@/views/private/setting/config/index.vue')
const setting_position = () => import(/* webpackPrefetch: true */ '@/views/private/setting/position/index.vue')
const setting_doc = () => import(/* webpackPrefetch: true */ '@/views/private/setting/doc/index.vue')
const setting_category = () => import(/* webpackPrefetch: true */ '@/views/private/setting/category/index.vue')

const evaluation_officer = () => import(/* webpackPrefetch: true */ '@/views/private/evaluation/officer/index.vue')
const evaluation_officer_main = () => import(/* webpackPrefetch: true */ '@/views/private/evaluation/officer/main_task/index.vue')
const evaluation_officer_main_detail_ketepatan_pekerjaan = () => import(/* webpackPrefetch: true */ '@/views/private/evaluation/officer/main_task/ketepatan_pekerjaan/_id.vue')
const evaluation_officer_main_detail_penilaian_atasan = () => import(/* webpackPrefetch: true */ '@/views/private/evaluation/officer/main_task/penilaian_atasan/_id.vue')
const evaluation_officer_main_detail_skor_presensi = () => import(/* webpackPrefetch: true */ '@/views/private/evaluation/officer/main_task/skor_presensi/_id.vue')

const evaluation_officer_aik = () => import(/* webpackPrefetch: true */ '@/views/private/evaluation/officer/aik/index.vue')
const evaluation_officer_aik_detail_pengajian = () => import(/* webpackPrefetch: true */ '@/views/private/evaluation/officer/aik/pengajian/_id.vue')
const evaluation_officer_aik_detail_hafalan = () => import(/* webpackPrefetch: true */ '@/views/private/evaluation/officer/aik/hafalan/_id.vue')
const evaluation_officer_aik_detail_keterlibatan = () => import(/* webpackPrefetch: true */ '@/views/private/evaluation/officer/aik/keterlibatan/_id.vue')
const evaluation_officer_aik_detail_lainnya = () => import(/* webpackPrefetch: true */ '@/views/private/evaluation/officer/aik/lainnya/_id.vue')
const evaluation_officer_aik_detail_pengembangan_ekonomi = () => import(/* webpackPrefetch: true */ '@/views/private/evaluation/officer/aik/pengembangan_ekonomi/_id.vue')

const evaluation_officer_additional = () => import(/* webpackPrefetch: true */ '@/views/private/evaluation/officer/additional_task/index.vue')
const evaluation_officer_additional_keterlibatan_pegawai = () => import(/* webpackPrefetch: true */ '@/views/private/evaluation/officer/additional_task/keterlibatan_pegawai/_id.vue')
const evaluation_officer_additional_pelatihan_sertifikat = () => import(/* webpackPrefetch: true */ '@/views/private/evaluation/officer/additional_task/pelatihan_sertifikat/_id.vue')
const evaluation_officer_additional_pengembangan_ekonomi = () => import(/* webpackPrefetch: true */ '@/views/private/evaluation/officer/additional_task/pengembangan_ekonomi/_id.vue')
const evaluation_officer_additional_sertifikasi_kompetensi = () => import(/* webpackPrefetch: true */ '@/views/private/evaluation/officer/additional_task/sertifikasi_kompetensi/_id.vue')


const evaluation_officer_summary = () => import(/* webpackPrefetch: true */ '@/views/private/evaluation/officer/summary/index.vue')

const evaluation_unit = () => import(/* webpackPrefetch: true */ '@/views/private/evaluation/unit/index.vue')

const event = () => import(/* webpackPrefetch: true */ '@/views/private/event/index.vue')
const event_detail = () => import(/* webpackPrefetch: true */ '@/views/private/event/_id.vue')

const question = () => import(/* webpackPrefetch: true */ '@/views/private/question/index.vue')

const routes = [
  {
    path: "/dashboard",
    name: "Dashboard",
    component: dashboard,
    meta: {
      title: "Dashboard"
    }
  },
  {
    path: "/profile",
    name: "Profil",
    component: profile,
    meta: {
      title: "Profil"
    }
  },
  {
    path: "/maping",
    name: "Maping",
    component: maping,
    meta: {
      title: "Maping"
    }
  },
  {
    path: "/attendance_monitoring",
    name: "Pegawai Presensi",
    component: attendance_monitoring,
    meta: {
      title: "Pegawai Presensi"
    }
  },
  {
    path: "/permission",
    name: "Pegawai Ijin",
    component: permission,
    meta: {
      title: "Pegawai Ijin"
    }
  },
  {
    path: "/unit",
    name: "Unit",
    component: unit,
    meta: {
      title: "Unit"
    }
  },
  {
    path: "/unit/structure",
    name: "Struktur Organisasi",
    component: unit_struktur,
    meta: {
      title: "Struktur Organisasi"
    }
  },
  {
    path: "/unit/structure/regulation",
    name: "Peraturan Struktur Organisasi",
    component: unit_struktur_regulation,
    meta: {
      title: "Peraturan Struktur Organisasi"
    }
  },
  {
    path: "/unit/structure/officer/:id",
    name: "Struktur Pegawai",
    component: unit_struktur_officer_id,
    meta: {
      title: "Struktur Pegawai"
    }
  },
  {
    path: "/unit/structure/officer/regulation/:id",
    name: "Peraturan Struktur Pegawai",
    component: unit_struktur_officer_regulation_id,
    meta: {
      title: "Peraturan Struktur Pegawai"
    }
  },
  {
    path: "/unit/division",
    name: "Data Unit / Divisi",
    component: unit_divisi,
    meta: {
      title: "Data Unit / Divisi"
    }
  },
  {
    path: "/unit/rule",
    name: "Aturan Organisasi",
    component: unit_aturan,
    meta: {
      title: "Aturan Organisasi"
    }
  },
  {
    path: "/officer",
    name: "Pegawai",
    component: officer,
    meta: {
      title: "Pegawai"
    }
  },
  {
    path: "/officer/:id",
    name: "Detail Pegawai",
    component: officer_detail,
    meta: {
      title: "Detail Pegawai"
    }
  },
  {
    path: "/attendance",
    name: "Data Presensi",
    component: attendance,
    meta: {
      title: "Data Presensi"
    }
  },
  {
    path: "/attendance/history/:id",
    name: "Riwayat Presensi",
    component: attendance_history,
    meta: {
      title: "Riwayat Presensi"
    }
  },
  {
    path: "/attendance/rekap",
    name: "Rekap Presensi",
    component: attendance_rekap,
    meta: {
      title: "Rekap Presensi"
    }
  },
  {
    path: "/attendance/late",
    name: "Keterlambatan",
    component: attendance_late,
    meta: {
      title: "Keterlambatan"
    }
  },
  {
    path: "/overtime",
    name: "Data Lembur",
    component: overtime,
    meta: {
      title: "Data Lembur"
    }
  },
  {
    path: "/overtime/history",
    name: "Riwayat Lembur",
    component: overtime_history,
    meta: {
      title: "Riwayat Lembur"
    }
  },
  {
    path: "/salary",
    name: "Gaji Sekarang",
    component: salary,
    meta: {
      title: "Gaji Sekarang"
    }
  },
  {
    path: "/salary/history/:id",
    name: "Riwayat Gaji",
    component: salary_history,
    meta: {
      title: "Riwayat Gaji"
    }
  },
  {
    path: "/salary/month",
    name: "Gaji Bulanan",
    component: salary_month,
    meta: {
      title: "Gaji Bulanan"
    }
  },
  {
    path: "/licensing",
    name: "Perijinan",
    component: licensing,
    meta: {
      title: "Perijinan"
    }
  },
  {
    path: "/licensing/holiday",
    name: "Data Sisa Cuti",
    component: licensing_holiday,
    meta: {
      title: "Data Sisa Cuti"
    }
  },
  {
    path: "/licensing/history/:id",
    name: "Riwayat Cuti",
    component: licensing_history,
    meta: {
      title: "Riwayat Cuti"
    }
  },
  {
    path: "/licensing/permission",
    name: "Riwayat Ijin & Cuti",
    component: licensing_permission,
    meta: {
      title: "Riwayat Ijin & Cuti"
    }
  },
  {
    path: "/licensing/submission",
    name: "Ajuan Ijin & Cuti",
    component: licensing_submission,
    meta: {
      title: "Ajuan Ijin & Cuti"
    }
  },
  {
    path: "/report",
    name: "Laporan Pegawai",
    component: report,
    meta: {
      title: "Laporan Pegawai"
    }
  },
  {
    path: "/report/history/:id",
    name: "Riwayat Laporan Pegawai",
    component: report_detail,
    meta: {
      title: "Riwayat Laporan Pegawai"
    }
  },
  {
    path: "/announcement",
    name: "Pengumuman",
    component: announcement,
    meta: {
      title: "Pengumuman"
    }
  },
  {
    path: "/audit",
    name: "Audit Trail",
    component: audit,
    meta: {
      title: "Audit Trail"
    }
  },
  {
    path: "/setting",
    name: "Konfigurasi",
    component: setting,
    meta: {
      title: "Konfigurasi"
    }
  },
  {
    path: "/setting/config",
    name: "Konfigurasi",
    component: setting_config,
    meta: {
      title: "Konfigurasi"
    }
  },
  {
    path: "/setting/position",
    name: "Posisi",
    component: setting_position,
    meta: {
      title: "Posisi"
    }
  },
  {
    path: "/setting/doc",
    name: "Tipe Dokumen",
    component: setting_doc,
    meta: {
      title: "Tipe Dokumen"
    }
  },
  {
    path: "/setting/category",
    name: "Kategori",
    component: setting_category,
    meta: {
      title: "Kategori"
    }
  },

  
  {
    path: "/evaluation/officer",
    name: "Penilaian Pegawai",
    component: evaluation_officer,
    meta: {
      title: "Penilaian Pegawai"
    }
  },
  {
    path: "/evaluation/officer/main",
    name: "Tugas Utama",
    component: evaluation_officer_main,
    meta: {
      title: "Tugas Utama"
    }
  },
  {
    path: "/evaluation/officer/main/ketepatan/:id",
    name: "Ketepatan Pekerjaan",
    component: evaluation_officer_main_detail_ketepatan_pekerjaan,
    meta: {
      title: "Ketepatan Pekerjaan"
    }
  },
  {
    path: "/evaluation/officer/main/atasan/:id",
    name: "Penilaian Atasan Langsung",
    component: evaluation_officer_main_detail_penilaian_atasan,
    meta: {
      title: "Penilaian Atasan Langsung"
    }
  },
  {
    path: "/evaluation/officer/main/skor/:id",
    name: "Skor Presensi",
    component: evaluation_officer_main_detail_skor_presensi,
    meta: {
      title: "Skor Presensi"
    }
  },

  {
    path: "/evaluation/officer/aik",
    name: "Kegiatan AIK",
    component: evaluation_officer_aik,
    meta: {
      title: "Kegiatan AIK"
    }
  },
  {
    path: "/evaluation/officer/aik/pengajian/:id",
    name: "Pengajian, tadarus, tafsir hadist di Unit Bisnis atau PT",
    component: evaluation_officer_aik_detail_pengajian,
    meta: {
      title: "Pengajian, tadarus, tafsir hadist di Unit Bisnis atau PT"
    }
  },
  {
    path: "/evaluation/officer/aik/hafalan/:id",
    name: "Hafalan surat Juz 30",
    component: evaluation_officer_aik_detail_hafalan,
    meta: {
      title: "Hafalan surat Juz 30"
    }
  },
  {
    path: "/evaluation/officer/aik/keterlibatan/:id",
    name: "Pengurus/Peserta AUM",
    component: evaluation_officer_aik_detail_keterlibatan,
    meta: {
      title: "Pengurus/Peserta AUM"
    }
  },
  {
    path: "/evaluation/officer/aik/lainnya/:id",
    name: "Kegiatan Lainnya",
    component: evaluation_officer_aik_detail_lainnya,
    meta: {
      title: "Kegiatan Lainnya"
    }
  },
  {
    path: "/evaluation/officer/aik/pengembangan/:id",
    name: "Pengembangan Ekonomi PT UMB",
    component: evaluation_officer_aik_detail_pengembangan_ekonomi,
    meta: {
      title: "Pengembangan Ekonomi PT UMB"
    }
  },

  {
    path: "/evaluation/officer/additional",
    name: "Tugas Tambahan",
    component: evaluation_officer_additional,
    meta: {
      title: "Tugas Tambahan"
    }
  },
  {
    path: "/evaluation/officer/additional/keterlibatan/:id",
    name: "Keterlibatan Pegawai Dilingkungan Sekitar",
    component: evaluation_officer_additional_keterlibatan_pegawai,
    meta: {
      title: "Keterlibatan Pegawai Dilingkungan Sekitar"
    }
  },
  {
    path: "/evaluation/officer/additional/pelatihan/:id",
    name: "Pelatihan Sertifikat",
    component: evaluation_officer_additional_pelatihan_sertifikat,
    meta: {
      title: "Pelatihan Sertifikat"
    }
  },
  {
    path: "/evaluation/officer/additional/sertifikasi/:id",
    name: "Sertifikasi Kompetensi",
    component: evaluation_officer_additional_sertifikasi_kompetensi,
    meta: {
      title: "Sertifikasi Kompetensi"
    }
  },
  {
    path: "/evaluation/officer/additional/pengembangan/:id",
    name: "Pengembangan Ekonomi",
    component: evaluation_officer_additional_pengembangan_ekonomi,
    meta: {
      title: "Pengembangan Ekonomi"
    }
  },

  {
    path: "/evaluation/officer/summary",
    name: "Summary Skor",
    component: evaluation_officer_summary,
    meta: {
      title: "Summary Skor"
    }
  },


  {
    path: "/evaluation/unit",
    name: "Penilaian Unit",
    component: evaluation_unit,
    meta: {
      title: "Penilaian Unit"
    }
  },


  {
    path: "/event",
    name: "Event",
    component: event,
    meta: {
      title: "Event"
    }
  },
  {
    path: "/event/:id",
    name: "Detail Event",
    component: event_detail,
    meta: {
      title: "Detail Event"
    }
  },

  {
    path: "/question",
    name: "Pertanyaan",
    component: question,
    meta: {
      title: "Pertanyaan"
    }
  }
]

export default routes.map(route => {
  const meta = {
    all: false, 
    public: false,
    title: route.meta.title
  }
  return { ...route, meta }
})